import { CanvaSX, renderChildren } from '../canvasx';
import { defaultShapeProps, getBorderColor, isFillStruct } from '../shapes';
import { applyFontStyles } from '../textRendering';

const defaultStyleProps = { ...defaultShapeProps };
export type StyleProps = Partial<
  Omit<ShapeStyle, 'borderRadius'> & { font?: Partial<FontStruct> }
>;

/**
 * The Style component is useful to apply fill/stroke styles without actually drawing anything.
 * This is useful to apply colors for <Text> across multiple components.
 */
export const Style: CanvaSXComponent<StyleProps, typeof defaultStyleProps> =
  function (props) {
    const { children, fill, border, font } = props;
    const { ctx } = CanvaSX.context;

    ctx.save();

    if (fill) {
      ctx.fillStyle = isFillStruct(fill) ? fill.color : fill;
    }

    if (border) {
      ctx.strokeStyle = getBorderColor(border) ?? 'black';
    }

    if (font) {
      applyFontStyles(ctx, font);
    }

    renderChildren(children);

    ctx.restore();

    return null;
  };

Style.defaultProps = defaultStyleProps;
